import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wallet } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/util";
import { Section, Money, Pill } from "@/components/common";

export default function FeesDue() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/fees/due-soon").then((r) => setList(r.data)).catch(() => setList(false)); }, []);
  if (!list) return null;
  return (
    <Section title={<span className="flex items-center gap-2"><Wallet className="w-5 h-5 text-orange-600" />رسوم غير مدفوعة قريبة الاستحقاق</span>}>
      <div data-testid="fees-due">
        {list.length === 0 ? <p className="text-slate-500 text-sm py-4">لا توجد رسوم مستحقة خلال 30 يوماً</p> : (
          <div className="divide-y">
            {list.map((f) => (
              <Link key={f.id} to={`/admin/drivers/${f.driver_id}`} data-testid={`fee-due-${f.id}`} className="py-2.5 flex items-center justify-between gap-3 text-sm hover:bg-slate-50 rounded-lg px-1">
                <span className="min-w-0"><b className="block truncate">{f.fee_label} — {f.driver_name}</b>
                  <span className="text-slate-500">يستحق {fmtDate(f.due_date)}</span></span>
                <span className="flex flex-col items-end gap-1 shrink-0"><Money fils={f.remaining_fils} className="text-red-600" />
                  <Pill color={f.days_left < 0 ? "red" : "orange"}>{f.days_left < 0 ? `متأخر ${-f.days_left} يوم` : f.days_left === 0 ? "اليوم" : `بعد ${f.days_left} يوم`}</Pill></span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Section>
  );
}
